export function addMouseflowTracker(trackingId, pilotId){
    window._mfq = window._mfq || [];
    var mf = document.createElement("script");
    mf.type = "text/javascript"; mf.async = true;
    mf.src = "//cdn.mouseflow.com/projects/" + trackingId + ".js";
    document.getElementsByTagName("head")[0].appendChild(mf);
    window._mfq.push(["setVariable", "pilotId", pilotId]);
}